module.exports = __webpack_public_path__ + "static/image/logo-family/logo_shopping_live@3x.png?8583d251";